import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MaskedInput from "../../../controls/MaskedInput";
import './PhoneNumberForm.css'

class PhoneNumberForm extends Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        hasError: false,
        countryCode: '7',
        phoneNumber: ''
    };

    render() {
        return (
            <div>
                <h2 className="m-t-0 m-b-4 text-xs-center font-weight-semibold font-size-20">Вход или регистрация</h2>
                <form className="panel p-a-4"
                      onSubmit={event => {
                          this.submitPhoneNumber();
                          event.preventDefault();
                      }}>
                    <fieldset className={`form-group form-group-lg ${this.state.hasError ? 'has-error' : ''}`}>
                        <label className="text-center m-b-2" htmlFor="phone-number">Введите номер телефона для получения
                            кода безопасности</label>
                        <div className="input-group">
                            <div className="input-group-addon">
                                <span className="flag-icon flag-icon-ru"/> +7
                            </div>
                            <MaskedInput type="text" className="form-control" id="phone-number"
                                         mask="(999) 999-9999"
                                         value={this.state.phoneNumber}
                                         onChange={event => this.setState({phoneNumber: event.target.value})}/>
                        </div>
                        {
                            this.state.hasError &&
                            <small class="form-message light">Укажите номер телефона</small>
                        }
                    </fieldset>
                    <button type="button" className="btn btn-block btn-lg btn-primary m-t-3"
                            disabled={!this.isFormValid()}
                            onClick={() => this.submitPhoneNumber()}>
                        Получить код
                    </button>
                </form>
            </div>
        );
    }

    isFormValid() {
        return this.state.phoneNumber.replace(/[^\d]/g, '').length === 10;
    }

    submitPhoneNumber() {
        const {onSubmit} = this.props;

        if (this.isFormValid()) {
            onSubmit(`${this.state.countryCode} ${this.state.phoneNumber}`)
        }
        else {
            this.setState({hasError: true});
        }
    }
}

export default PhoneNumberForm;


// WEBPACK FOOTER //
// ./src/pages/Login/components/PhoneNumberForm.js